import { useEffect } from "react";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../store";
import { pricingUtils } from "@flights/web-api-utils-universal";
import { goal } from "@flights/et-universal";

const useTrackFlightDetailsPriceChangeGoal = () => {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const { flightDetails, searchResults } = store;

  useEffect(() => {
    if (flightDetails.flight) {
      const flightDetailsFromSearchResults = searchResults.flights.find(
        (flightItem) => flightItem.token == flightDetails.flight?.token
      );
      if (flightDetailsFromSearchResults) {
        const totalPrice = pricingUtils.priceToNumber(flightDetails.flight.priceBreakdown.total);
        const searchResultsTotalPrice = pricingUtils.priceToNumber(flightDetailsFromSearchResults.priceBreakdown.total);
        if (totalPrice != searchResultsTotalPrice) {
          goal("flights_flight_details_price_change");
        }
      }
    }
  }, [searchResults, flightDetails]);
};
export default useTrackFlightDetailsPriceChangeGoal;
